import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaBullseye,
  FaEye,
  FaBalanceScale,
  FaLeaf,
  FaHandshake,
  FaShieldAlt,
  FaHeart,
  FaRocket,
  FaArrowLeft,
  FaCheckCircle,
  FaUsers,
  FaGlobe,
  FaTruckMoving,
  FaChartLine,
} from "react-icons/fa";
import logo1 from "../Images/para.png";

const missions = [
  {
    icon: <FaTruckMoving />,
    title: "Reliable LR Movement",
    desc: "Ensure safe, on-time delivery of every consignment through optimized routing and fleet management.",
  },
  {
    icon: <FaUsers />,
    title: "Customer-First Approach",
    desc: "Build lasting relationships by putting client needs at the center of everything we do.",
  },
  {
    icon: <FaGlobe />,
    title: "Pan-India Connectivity",
    desc: "Expand our network to connect every major business hub with seamless logistics solutions.",
  },
  {
    icon: <FaRocket />,
    title: "Innovation in Logistics",
    desc: "Leverage technology to bring transparency, efficiency, and intelligence to freight operations.",
  },
];

const visions = [
  {
    icon: <FaEye />,
    title: "India's Most Trusted Transporter",
    desc: "To be recognized as the most reliable and customer-focused road freight company in India.",
  },
  {
    icon: <FaChartLine />,
    title: "Sustainable Growth",
    desc: "Achieve consistent growth while maintaining the highest standards of service quality and safety.",
  },
  {
    icon: <FaGlobe />,
    title: "200+ Cities by 2027",
    desc: "Expand our operational footprint to cover 200+ cities with dedicated logistics infrastructure.",
  },
  {
    icon: <FaLeaf />,
    title: "Green Logistics",
    desc: "Transition to cleaner fuel alternatives and reduce carbon footprint across our fleet operations.",
  },
];

const policies = [
  {
    icon: <FaShieldAlt />,
    title: "Zero Damage Commitment",
    desc: "Every shipment is handled with utmost care. We maintain industry-leading damage-free delivery rates.",
  },
  {
    icon: <FaBalanceScale />,
    title: "Transparent Operations",
    desc: "No hidden charges, clear documentation, and real-time visibility into every shipment movement.",
  },
  {
    icon: <FaHandshake />,
    title: "Ethical Business Practices",
    desc: "We operate with integrity, fairness, and respect for all stakeholders in the supply chain.",
  },
  {
    icon: <FaHeart />,
    title: "Employee Welfare",
    desc: "Our team is our strength. We invest in training, safety, and well-being of every team member.",
  },
];

const values = [
  { icon: <FaCheckCircle />, label: "Integrity" },
  { icon: <FaCheckCircle />, label: "Reliability" },
  { icon: <FaCheckCircle />, label: "Transparency" },
  { icon: <FaCheckCircle />, label: "Innovation" },
  { icon: <FaCheckCircle />, label: "Safety" },
  { icon: <FaCheckCircle />, label: "Excellence" },
];

function MissionVision() {
  const navigate = useNavigate();

  return (
    <div className="mv-page">
      <div style={{ paddingTop: "68px" }}>

        {/* Hero */}
        <section className="mv-hero">
          <div className="mv-hero-bg" />
          <div className="mv-hero-content">
            <div className="mv-hero-badge">
              <img src={logo1} alt="Paras Roadlines" className="mv-hero-logo" />
            </div>
            <div className="mv-tag-row">
              <span className="mv-tag-line" />
              <span className="mv-tag">Our Purpose</span>
              <span className="mv-tag-line" />
            </div>
            <h1>Mission, Vision<br />& Core Values</h1>
            <p>
              The principles that guide our journey and the goals that drive us
              to deliver excellence every single day.
            </p>
          </div>
        </section>

        {/* Mission */}
        <section className="mv-section">
          <div className="mv-container">
            <div className="mv-sec-header">
              <div className="mv-icon-circle mv-mission-icon">
                <FaBullseye />
              </div>
              <div className="mv-tag-row">
                <span className="mv-stag-line" />
                <span className="mv-stag">Our Mission</span>
                <span className="mv-stag-line" />
              </div>
              <h2>What Drives Us Every Day</h2>
              <p>Our commitment to moving businesses forward with reliability and innovation</p>
            </div>
            <div className="mv-cards-grid">
              {missions.map(({ icon, title, desc }) => (
                <div className="mv-card" key={title}>
                  <div className="mv-card-icon">{icon}</div>
                  <h3>{title}</h3>
                  <p>{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Vision */}
        <section className="mv-section mv-section-alt">
          <div className="mv-container">
            <div className="mv-sec-header">
              <div className="mv-icon-circle mv-vision-icon">
                <FaEye />
              </div>
              <div className="mv-tag-row">
                <span className="mv-stag-line" />
                <span className="mv-stag">Our Vision</span>
                <span className="mv-stag-line" />
              </div>
              <h2>Where We're Headed</h2>
              <p>The future we're building — for our clients, our team, and our industry</p>
            </div>
            <div className="mv-cards-grid">
              {visions.map(({ icon, title, desc }) => (
                <div className="mv-card mv-card-vision" key={title}>
                  <div className="mv-card-icon mv-card-icon-vision">{icon}</div>
                  <h3>{title}</h3>
                  <p>{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Core Values */}
        <section className="mv-section">
          <div className="mv-container">
            <div className="mv-sec-header">
              <div className="mv-tag-row">
                <span className="mv-stag-line" />
                <span className="mv-stag">Core Values</span>
                <span className="mv-stag-line" />
              </div>
              <h2>The Pillars We Stand On</h2>
            </div>
            <div className="mv-values-grid">
              {values.map(({ icon, label }) => (
                <div className="mv-value-chip" key={label}>
                  <span className="mv-value-icon">{icon}</span>
                  <span>{label}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Policy */}
        <section className="mv-section mv-section-alt">
          <div className="mv-container">
            <div className="mv-sec-header">
              <div className="mv-icon-circle mv-policy-icon">
                <FaBalanceScale />
              </div>
              <div className="mv-tag-row">
                <span className="mv-stag-line" />
                <span className="mv-stag">Our Policies</span>
                <span className="mv-stag-line" />
              </div>
              <h2>How We Operate</h2>
              <p>Standards and commitments that define our business practices</p>
            </div>
            <div className="mv-cards-grid">
              {policies.map(({ icon, title, desc }) => (
                <div className="mv-card mv-card-policy" key={title}>
                  <div className="mv-card-icon mv-card-icon-policy">{icon}</div>
                  <h3>{title}</h3>
                  <p>{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>

      <style>{`
        .mv-page{
          font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;
          background:#ffffff;color:#101828;min-height:100vh;
        }
        .mv-container{max-width:1100px;margin:0 auto;padding:0 clamp(16px,3vw,40px);}

        /* Hero */
        .mv-hero{
          position:relative;
          background:linear-gradient(135deg,#101636 0%,#1a1f4e 100%);
          padding:clamp(60px,10vh,100px) 0 clamp(50px,8vh,80px);
          overflow:hidden;text-align:center;
        }
        .mv-hero-bg{
          position:absolute;inset:0;
          background-image:
            radial-gradient(ellipse at 25% 50%,rgba(79,70,229,.2),transparent 50%),
            radial-gradient(ellipse at 75% 50%,rgba(245,158,11,.1),transparent 50%),
            linear-gradient(rgba(255,255,255,.03) 1px,transparent 1px),
            linear-gradient(90deg,rgba(255,255,255,.03) 1px,transparent 1px);
          background-size:100% 100%,100% 100%,50px 50px,50px 50px;
        }
        .mv-hero-content{position:relative;z-index:2;max-width:650px;margin:0 auto;padding:0 20px;}
        .mv-hero-badge{
          width:80px;height:80px;margin:0 auto 1.5rem;
          background:rgba(255,255,255,.08);border:2px solid rgba(255,255,255,.15);
          border-radius:20px;display:flex;align-items:center;justify-content:center;
        }
        .mv-hero-logo{width:56px;height:56px;object-fit:contain;}
        .mv-hero h1{font-size:clamp(1.8rem,4vw,2.8rem);font-weight:900;color:#fff;line-height:1.15;letter-spacing:-1px;margin-bottom:1rem;}
        .mv-hero p{color:rgba(255,255,255,.6);font-size:.9rem;line-height:1.8;max-width:500px;margin:0 auto;}

        /* Tags */
        .mv-tag-row{display:flex;align-items:center;justify-content:center;gap:14px;margin-bottom:.75rem;}
        .mv-tag-line{width:40px;height:1px;background:rgba(255,255,255,.2);}
        .mv-tag{font-size:.6rem;font-weight:800;letter-spacing:3px;text-transform:uppercase;color:#fbbf24;}
        .mv-stag-line{width:40px;height:1px;background:#c7cbe8;}
        .mv-stag{font-size:.6rem;font-weight:800;letter-spacing:3px;text-transform:uppercase;color:#4f46e5;}

        /* Sections */
        .mv-section{padding:clamp(50px,8vh,90px) 0;}
        .mv-section-alt{background:#f8f9fc;}
        .mv-sec-header{text-align:center;margin-bottom:clamp(2rem,4vh,3rem);}
        .mv-sec-header h2{font-size:clamp(1.4rem,2.5vw,2.2rem);font-weight:900;color:#101828;letter-spacing:-.5px;margin-bottom:.5rem;line-height:1.2;}
        .mv-sec-header p{color:#6b7280;font-size:.88rem;max-width:480px;margin:0 auto;line-height:1.7;}

        .mv-icon-circle{
          width:64px;height:64px;border-radius:50%;
          display:flex;align-items:center;justify-content:center;
          margin:0 auto 1rem;font-size:1.4rem;
        }
        .mv-mission-icon{background:#eef2ff;color:#4f46e5;border:2px solid #d7dafc;}
        .mv-vision-icon{background:#fef3c7;color:#d97706;border:2px solid #fde68a;}
        .mv-policy-icon{background:#ecfdf5;color:#059669;border:2px solid #a7f3d0;}

        /* Cards Grid */
        .mv-cards-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:1.25rem;}

        .mv-card{
          background:#fff;border:1px solid #e6e8f0;border-radius:16px;
          padding:1.5rem;transition:all .3s;position:relative;overflow:hidden;
        }
        .mv-card::before{
          content:'';position:absolute;bottom:0;left:0;width:0;height:3px;
          background:linear-gradient(90deg,#4f46e5,#4338ca);transition:width .35s;
        }
        .mv-card:hover::before{width:100%;}
        .mv-card:hover{transform:translateY(-3px);box-shadow:0 12px 28px rgba(16,24,40,.06);border-color:#d7dafc;}

        .mv-card-icon{
          width:44px;height:44px;background:#eef2ff;border-radius:12px;
          display:flex;align-items:center;justify-content:center;margin-bottom:1rem;
          transition:all .3s;
        }
        .mv-card-icon svg{font-size:1.1rem;color:#4f46e5;transition:color .3s;}
        .mv-card:hover .mv-card-icon{background:linear-gradient(135deg,#4f46e5,#4338ca);}
        .mv-card:hover .mv-card-icon svg{color:#fff;}

        .mv-card h3{font-size:.88rem;font-weight:700;color:#101828;margin-bottom:.4rem;text-align:left;}
        .mv-card p{font-size:.78rem;color:#6b7280;line-height:1.7;text-align:left;}

        /* Vision card variant */
        .mv-card-vision::before{background:linear-gradient(90deg,#f59e0b,#d97706);}
        .mv-card-icon-vision{background:#fef3c7;}
        .mv-card-icon-vision svg{color:#d97706;}
        .mv-card-vision:hover .mv-card-icon-vision{background:linear-gradient(135deg,#f59e0b,#d97706);}
        .mv-card-vision:hover .mv-card-icon-vision svg{color:#fff;}

        /* Policy card variant */
        .mv-card-policy::before{background:linear-gradient(90deg,#059669,#047857);}
        .mv-card-icon-policy{background:#ecfdf5;}
        .mv-card-icon-policy svg{color:#059669;}
        .mv-card-policy:hover .mv-card-icon-policy{background:linear-gradient(135deg,#059669,#047857);}
        .mv-card-policy:hover .mv-card-icon-policy svg{color:#fff;}

        /* Values */
        .mv-values-grid{display:flex;flex-wrap:wrap;justify-content:center;gap:1rem;}
        .mv-value-chip{
          display:inline-flex;align-items:center;gap:8px;
          background:#fff;border:1px solid #e6e8f0;border-radius:999px;
          padding:12px 20px;font-size:.82rem;font-weight:700;color:#101828;
          transition:all .3s;
        }
        .mv-value-chip:hover{
          background:#eef2ff;border-color:#d7dafc;
          transform:translateY(-2px);box-shadow:0 6px 16px rgba(16,24,40,.05);
        }
        .mv-value-icon{color:#4f46e5;font-size:.9rem;display:flex;}

        /* Responsive */
        @media(max-width:768px){
          .mv-cards-grid{grid-template-columns:1fr;}
        }
        @media(max-width:480px){
          .mv-values-grid{gap:.75rem;}
          .mv-value-chip{padding:10px 16px;font-size:.75rem;}
        }
      `}</style>
    </div>
  );
}

export default MissionVision;